import React from "react"

import FetchQBData from './fetch_qb_data'

import career_styles from '../components/era_adj_elo.module.scss'
import EloChart from "./elo_career_chart"

const EloCareerTable = ({qbs}) => {



    const careerData = FetchQBData(
        'https://b8kngguc7d.execute-api.us-east-2.amazonaws.com/prod/qb-elo-career',
        qbs
    )
    
    console.log(careerData)

    return(
        <div className={career_styles.career_wrapper}>

            {(careerData[0] === 'Loading') ? (
                    <p>Loading...</p>
            ) : (
                <EloChart
                    data={careerData}
                />
            )}

        </div>

    )

}

export default EloCareerTable